let button = document.getElementById("backToTop-button");

function scrollFunction() {
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    button.classList.remove("offScreen");
  } else {
    button.classList.add("offScreen");
  }
}
window.onscroll = function() {scrollFunction()};

function backToTop() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}
button.addEventListener("click", backToTop);